import type { PaymentProvider } from 'pkg/api/models/group';

export enum AutoChargeOptions {
	Always = 'always',
	Settable = 'settable',
}

export enum RecurringInterval {
	Day = 'day',
	Week = 'week',
	Month = 'month',
	Year = 'year',
}

export type RecurringOptionStrings =
	| 'annually'
	| 'semiAnnually'
	| 'daily'
	| 'weekly'
	| 'biweekly'
	| 'bimonthly'
	| 'quarterly'
	| 'monthly'
	| 'custom';

export interface AvailableRecurringOptions {
	recurringInterval: RecurringInterval;
	recurringIntervalCount: number;
}

export interface ProviderSettings {
	provider?: PaymentProvider;
	allowProration: boolean;
	allowTrialPeriod: boolean;
	allowSubscriptionReactivation: boolean;
	autoCharge: AutoChargeOptions;
	canResetBillingCycle: boolean;
	canScheduleCancelSubscription: boolean;
	orderDescriptionMaxLength: number;
	subscriptionDescriptionMaxLength: number;
	canHaveServiceFee: boolean;
	availableRecurringOptions: {
		[key in RecurringOptionStrings]?: AvailableRecurringOptions;
	};
	allowCustomRecurringCombinations: boolean;
	allowReminderActionOnAutoChargedOrders: boolean;
	canHaveDiscountCode: boolean;
	canHaveDelayedSubscriptionStart: boolean;
	balanceReportAvailable: boolean;
	showPaymentMethods: boolean;
	externalSubscriptionSchedule: boolean;
}
